import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "data-node" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Handle = _resolveComponent("Handle")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Handle, {
      id: "treeDataNode",
      type: "source",
      position: _ctx.Position.Left,
      connectable: false,
      style: {"opacity":"0"}
    }, null, 8, ["position"]),
    _createElementVNode("span", null, _toDisplayString(_ctx.label), 1),
    _createVNode(_component_Handle, {
      id: "sourceDataNode",
      type: "source",
      position: _ctx.Position.Right,
      connectable: _ctx.handleConnectable,
      style: {"background":"#ff0072"}
    }, null, 8, ["position", "connectable"])
  ]))
}